import { TagChip } from "@web/components/tag/TagChip";
import { useTagNavigation } from "@web/route-services/index/use-tag-navigation";
import { Route } from "@web/routes";
import { motion } from "motion/react";

export function TagDisplay() {
  const { tags = [] } = Route.useSearch();
  const { remove } = useTagNavigation();

  if (!tags.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 py-2">
      {tags.map((tag) => (
        <motion.div
          key={tag}
          initial={{ opacity: 0, scale: 0.89 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.2,
            ease: [0, 0.71, 0.2, 1.01]
          }}
          className=""
        >
          <TagChip tag={tag} clearable={true} onSelect={remove} />
        </motion.div>
      ))}
    </div>
  );
}
